/* HĀ WORLDWIDE remodel — scroll reveals, hero parallax, featured-drop variant picker, FAQ accordion. */
(function () {
  'use strict';
  // header height -> --ha-hdr so the hero fills exactly the first viewport
  var setHdr=function(){var h=document.querySelector('#header-component, header-component, .header, header'); if(h) document.documentElement.style.setProperty('--ha-hdr', Math.round(h.getBoundingClientRect().height)+'px');};
  setHdr(); window.addEventListener('resize', setHdr); window.addEventListener('load', setHdr);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Split headline words for staggered rise (elements with .ha-words) */
  function splitWords(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var nodes = Array.prototype.slice.call(el.childNodes);
    var i = 0;
    var frag = document.createDocumentFragment();
    nodes.forEach(function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
          // keep leading punctuation glued to the previous word (e.g. "<em>Dunya</em>.")
          var pm = part.match(/^([.,!?;:\u2019\u201d)\]]+)(.*)$/);
          if (pm && frag.lastChild && frag.lastChild.classList && frag.lastChild.classList.contains('ha-w')) {
            frag.lastChild.firstChild.appendChild(document.createTextNode(pm[1]));
            part = pm[2]; if (!part) return;
          }
          var w = document.createElement('span'); w.className = 'ha-w';
          var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--d', (i++ * 0.08) + 's');
          w.appendChild(s); frag.appendChild(w);
        });
      } else if (n.nodeType === 1) {
        var w2 = document.createElement('span'); w2.className = 'ha-w';
        var s2 = document.createElement('span'); s2.style.setProperty('--d', (i++ * 0.08) + 's');
        s2.appendChild(n.cloneNode(true)); w2.appendChild(s2); frag.appendChild(w2);
      }
    });
    el.innerHTML = ''; el.appendChild(frag);
  }

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.ha-reveal, .ha-words');
    if (!els.length) return;
    els.forEach(function (el) { if (el.classList.contains('ha-words')) splitWords(el); });
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Hero parallax */
  function initHero() {
    document.querySelectorAll('.ha-hero').forEach(function (hero) {
      var media = hero.querySelector('.ha-hero__media');
      var inner = hero.querySelector('.ha-hero__inner');
      if (!media || reduce) return;
      var ticking = false;
      function update() {
        var r = hero.getBoundingClientRect();
        var p = Math.min(Math.max(-r.top / (r.height || 1), 0), 1);
        media.style.transform = 'translate3d(0,' + (p * 18) + '%,0)';
        if (inner) { inner.style.opacity = String(1 - p * 1.4); inner.style.transform = 'translate3d(0,' + (p * -40) + 'px,0)'; }
        ticking = false;
      }
      window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
      update();
    });
  }

  /* Featured drop — variant resolution + gallery */
  function initDrop() {
    document.querySelectorAll('[data-ha-drop]').forEach(function (sec) {
      var data = sec.querySelector('[data-variants]');
      var form = sec.querySelector('form[data-ha-atc]');
      if (!data || !form) return;
      var variants = JSON.parse(data.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-atc-btn]');
      var priceEl = sec.querySelector('[data-price]');
      var mainImgs = sec.querySelectorAll('.ha-drop__main img');
      var thumbs = sec.querySelectorAll('.ha-drop__thumb');
      var money = function (cents) {
        var fmt = sec.dataset.money || '${{amount}}';
        var amt = (cents / 100).toFixed(2);
        return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amt);
      };
      function showImage(idx) {
        mainImgs.forEach(function (im, i) { im.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('mouseenter', function () { showImage(i); });
        t.addEventListener('click', function (e) { e.preventDefault(); showImage(i); });
      });
      function resolve() {
        var chosen = [];
        sec.querySelectorAll('.ha-drop__opt').forEach(function (opt) {
          var checked = opt.querySelector('input:checked');
          chosen.push(checked ? checked.value : null);
        });
        var v = variants.find(function (vv) { return vv.options.every(function (o, i) { return o === chosen[i]; }); });
        if (v) {
          idInput.value = v.id;
          if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price && v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
          if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? btn.dataset.add : btn.dataset.soldout; }
          var fm = v.featured_media || v.featured_image; if (fm && fm.position) { var idx = fm.position - 1; if (mainImgs[idx]) showImage(idx); }
        } else if (btn) { btn.disabled = true; btn.querySelector('span').textContent = btn.dataset.unavailable; }
      }
      sec.querySelectorAll('.ha-drop__opt input').forEach(function (inp) { inp.addEventListener('change', resolve); });
      resolve();
      /* Progressive enhancement: add via fetch so the cart drawer count updates; fall back to normal submit */
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var original = btn.querySelector('span').textContent;
        btn.disabled = true; btn.querySelector('span').textContent = btn.dataset.adding;
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j && res.j.description || 'error');
            btn.querySelector('span').textContent = btn.dataset.added;
            setTimeout(function () { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; }, 350);
          })
          .catch(function () { btn.disabled = false; btn.querySelector('span').textContent = original; form.submit(); });
      });
    });
  }

  /* FAQ */
  function initFaq() {
    document.querySelectorAll('.ha-faq__item').forEach(function (item) {
      var q = item.querySelector('.ha-faq__q');
      if (!q) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.ha-faq__item.is-open').forEach(function (o) { o.classList.remove('is-open'); o.querySelector('.ha-faq__q').setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* Newsletter (AJAX-less: rely on Shopify form redirect; show success from URL param) */
  function initNews() {
    document.querySelectorAll('.ha-news').forEach(function (sec) {
      if (/customer_posted=true/.test(window.location.search)) {
        var ok = sec.querySelector('[data-news-ok]'); if (ok) ok.hidden = false;
        var f = sec.querySelector('form'); if (f) f.hidden = true;
      }
    });
  }


  /* 3D spin: scroll-driven turntable built from the product's angle photos */
  function initSpin() {
    document.querySelectorAll('[data-ha-spin]').forEach(function (sec) {
      if (sec.dataset.init) return; sec.dataset.init = '1';
      var track = sec.querySelector('.ha-spin__track');
      var obj = sec.querySelector('[data-ha-spin-obj]');
      var frames = Array.prototype.slice.call(sec.querySelectorAll('.ha-spin__frame'));
      var shadow = sec.querySelector('[data-ha-spin-shadow]');
      var idxEl = sec.querySelector('[data-ha-spin-idx]');
      var labelEl = sec.querySelector('[data-ha-spin-label]');
      var degEl = sec.querySelector('[data-ha-spin-deg]');
      var ring = sec.querySelector('[data-ha-spin-ring]');
      var word = sec.querySelector('[data-ha-spin-word]');
      var labels = (labelEl && labelEl.dataset.labels ? labelEl.dataset.labels.split(',') : ['Front', 'Side', 'Back', 'Side']).map(function (s) { return s.trim(); });
      var turns = parseInt(sec.dataset.turns || '1', 10) || 1;
      var n = frames.length || 1;
      var mx = 0, my = 0, tmx = 0, tmy = 0, cur = -1, ticking = false, lastAngle = 0;
      if (!track || !obj || !frames.length) return;
      if (reduce) { frames[0].classList.add('is-active'); return; }
      function setFrame(i) {
        if (i === cur) return; cur = i;
        frames.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
        if (idxEl) idxEl.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        if (labelEl) labelEl.textContent = labels[i % labels.length] || '';
      }
      function render() {
        ticking = false;
        var r = track.getBoundingClientRect();
        var vh = window.innerHeight;
        var total = r.height - vh;
        var p = total > 0 ? Math.min(Math.max(-r.top / total, 0), 1) : 0;
        var angle = p * 360 * turns;                 // full rotation(s) across the pinned scroll
        var a = ((angle % 360) + 360) % 360;
        var seg = 360 / n;
        var i = Math.round(a / seg) % n;             // nearest photographed angle
        var tilt = ((a + seg / 2) % seg) - seg / 2;  // -seg/2 .. seg/2 within the segment
        var yaw = tilt * 0.55;                       // soften so the flat photo never edges on
        // ease mouse
        mx += (tmx - mx) * 0.08; my += (tmy - my) * 0.08;
        var floatY = Math.sin(p * Math.PI * 2 * turns) * 10;
        obj.style.transform = 'rotateX(' + (my * -6) + 'deg) rotateY(' + (yaw + mx * 8) + 'deg) translate3d(0,' + floatY + 'px,0)';
        setFrame(i);
        if (shadow) { var sc = 1 - Math.abs(tilt) / seg * 0.5; shadow.style.transform = 'translateX(-50%) scaleX(' + sc + ')'; shadow.style.opacity = String(0.6 + sc * 0.4); }
        if (degEl) degEl.textContent = Math.round(a) + '°';
        if (ring) ring.style.strokeDashoffset = String(301.6 * (1 - p));
        if (word) word.style.transform = 'translate(-50%,-50%) rotate(-6deg) translateX(' + ((p - 0.5) * -22) + 'vw)';
        lastAngle = a;
        if (Math.abs(tmx - mx) > 0.002 || Math.abs(tmy - my) > 0.002) { requestAnimationFrame(render); ticking = true; }
      }
      function request() { if (!ticking) { ticking = true; requestAnimationFrame(render); } }
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      if (window.matchMedia('(pointer:fine)').matches) {
        sec.addEventListener('mousemove', function (e) { var rr = sec.getBoundingClientRect(); tmx = (e.clientX - rr.left) / rr.width * 2 - 1; tmy = (e.clientY - Math.max(rr.top, 0)) / Math.min(rr.height, window.innerHeight) * 2 - 1; request(); });
        sec.addEventListener('mouseleave', function () { tmx = 0; tmy = 0; request(); });
      }
      render();
    });
  }

  function init() { initReveals(); initHero(); initDrop(); initFaq(); initNews(); initSpin(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); initHero(); initDrop(); initFaq(); initSpin(); });
})();
